import React, { createContext, useContext, useState, ReactNode } from 'react';

interface HeroImageContextType {
  heroImage: string | null;
  setHeroImage: (image: string | null) => void;
}

const HeroImageContext = createContext<HeroImageContextType | undefined>(
  undefined,
);

export const useHeroImage = (): HeroImageContextType => {
  const context = useContext(HeroImageContext);
  if (!context) {
    // Fallback no-op when used outside a provider so consumers don't crash
    return { heroImage: null, setHeroImage: () => {} };
  }
  return context;
};

interface HeroImageProviderProps {
  children: ReactNode;
}

export const HeroImageProvider: React.FC<HeroImageProviderProps> = ({
  children,
}) => {
  const [heroImage, setHeroImage] = useState<string | null>(null);

  return (
    <HeroImageContext.Provider value={{ heroImage, setHeroImage }}>
      {children}
    </HeroImageContext.Provider>
  );
};
